import { createReducer } from "@reduxjs/toolkit";
import {
	API_GET_SAFEPLACE_APPOINTMENT,
	API_GET_SAFEPLACE_APPOINTMENT_SUCCESS,
	API_GET_SAFEPLACE_APPOINTMENT_FAIL,
	API_GET_ALL_SAFEPLACE_QRCODE_SUCCESS,
	API_GET_ALL_SAFEPLACE_QRCODE,
	SET_QR_SEARCH,
} from "actions/safeplace";
import { ErrorAction, errorHandler } from "utils/error";
import { toast } from "react-toastify";
import moment from "moment";

const initialState = {
	list: {
		data: [],
		loading: false,
	},
	current: {
		data: {},
		folder: {},
		loading: false,
	},
	safeplaceQR: null,
	preregisterQR: null,
};

const getErrorMessageFromSafeplace = (data) => {
	try {
		switch (data.code) {
			case "valid_from_error":
				return `Ce QR code n'est valide qu'à partir du ${moment(data.valid_from).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT)} jusqu'au ${moment(
					data.valid_to
				).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT)}.`;
			case "used":
				return `Ce QR code a déjà été utilisé.`;
			case "canceled":
				return `Ce QR code a été annulé.`;
			case "valid_to_error":
				return `Ce QR code n'est plus valide. (Date d'expiration: ${moment(data.valid_to).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT)})`;
			default:
				return "Ce QR code est invalide ou n’a pas été trouvé dans notre base de donnée.";
		}
	} catch (e) {
		return "Une erreur s'est produite lors de la récupération des informations du QR code.";
	}
};
const safeplace = createReducer(initialState, {
	/** GET BY DATE **/
	[API_GET_SAFEPLACE_APPOINTMENT]: (state, action) => {
		state.current.loading = true;
		state.current.data = {};
	},
	[API_GET_SAFEPLACE_APPOINTMENT_SUCCESS]: (state, action) => {
		state.current.loading = false;
		if (action.payload.data.status === 404) {
			state.current.data = {};
			state.current.folder = {};
			toast.error(getErrorMessageFromSafeplace(action.payload.data));
		} else {
			state.current.data = action.payload.data.data;
			state.current.folder = action.payload.data.folder;
		}
	},
	[API_GET_SAFEPLACE_APPOINTMENT_FAIL]: (state, action) => {
		state.current.loading = false;
		state.current.data = {};
		errorHandler("Safeplace", ErrorAction.READ, action.error);
		toast.error("Une erreur s'est produite lors de la récupération des informations du QR code.");
	},
	[API_GET_ALL_SAFEPLACE_QRCODE]: (state, action) => {
		state.list.loading = true;
	},
	[API_GET_ALL_SAFEPLACE_QRCODE_SUCCESS]: (state, action) => {
		state.list.loading = false;
		if (action.payload.data && action.payload.data.error) toast.error(action.payload.data.error);
		else state.list.data = action.payload.data;
	},

	[SET_QR_SEARCH]: (state, action) => {
		state.safeplaceQR = action.data;
	},
});

export default safeplace;
